<div class="background-image" [class.shadow]="title || subtitle">
  <figure *ngIf="media">
    <mb-media class="absolute-centered" [media]="media"></mb-media>
  </figure>
</div>

<div class="stage-content">
  <div>
    <div *ngIf="topline" class="topline" [innerHTML]="topline"></div>
  </div>
  <div>
    <h1 class="stage-title" [innerHtml]="title"></h1>
    <p class="stage-subtitle" [innerHtml]="subtitle"></p>
  </div>
  <div class="stage-footer">
    <p *ngIf="fuelLabel" class="fuel-label copy-s" [innerHTML]="fuelLabel"></p>
  </div>
</div>
